import React, { FC, useMemo } from 'react';
import { startCase } from 'lodash';
import { Box, Menu, MenuItem } from '@mui/material';
import { CommonProps, ICategory } from './constants';
import { IconHorizontalDot } from '../../../utils/icons';

interface Props extends CommonProps {
  category: ICategory;
}

export const CategoryActions: FC<Props> = ({ category, handlers }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const onClose = () => setAnchorEl(null);

  if (!category || !handlers) return null;
  const { onEdit, onPublish } = handlers;

  const statusOption = useMemo(
    () => (category.status === 'published' ? 'Draft' : 'Publish'),
    [category.status]
  );

  const onEditOptionClick = () => {
    onEdit?.(category);
    onClose();
  };

  const onStatusUpdate = () => {
    const updatedStatus =
      category.status === 'published' ? 'draft' : 'published';
    onPublish?.(category.id, updatedStatus);
    onClose();
  };

  return (
    <Box>
      <Box
        className="flex items-center justify-center cursor-pointer"
        onClick={(ev) => setAnchorEl(ev.currentTarget)}
      >
        <IconHorizontalDot />
      </Box>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {onEdit && <MenuItem onClick={onEditOptionClick}>Edit</MenuItem>}
        {onPublish && (
          <MenuItem onClick={onStatusUpdate}>
            {startCase(statusOption)}
          </MenuItem>
        )}
      </Menu>
    </Box>
  );
};
